import React from 'react';
import PropTypes from 'prop-types';

import GoogleLinkedText from './GoogleLinkedText';
import GoogleNotLinkedText from './GoogleNotLinkedText';

import ChooseCalendars from './ChooseCalendars';

export default function Google({ calendars }) {
  const infoText = calendars.attributes.is_google_calendar_linked ? <GoogleLinkedText /> : <GoogleNotLinkedText />;

  return (
    <div className="mt-4">
      <div className="mb-3 row">
        <div className="col-lg-6 mt-2">
          {infoText}
          {calendars.attributes.is_google_calendar_linked
          && (
          <ChooseCalendars calendarType="google" calendars={calendars.attributes.google_calendars} />
          )}
        </div>
        <div className="col-lg-6 mt-2">
          <div className="d-flex justify-content-end">
            <a
              // onClick={onDeleteAccount}
              className="btn btn-outline-primary"
              href={calendars.attributes.google_calendar_action}
            >
              Google Account
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

Google.propTypes = {
  calendars: PropTypes.object.isRequired,
};
